import React from 'react';
import { Share2 } from 'lucide-react';
import { useSelector } from 'react-redux';
import { RootState } from '../../store';

interface ShareButtonProps {
  onShare: () => void;
  onAuthRequired: () => void;
  disabled?: boolean;
  isActive?: boolean;
}

export const ShareButton: React.FC<ShareButtonProps> = ({
  onShare,
  onAuthRequired,
  disabled = false,
  isActive = false,
}) => {
  const { user } = useSelector((state: RootState) => state.auth);

  const handleClick = () => {
    if (!user) {
      onAuthRequired();
      return;
    }
    onShare();
  };

  return (
    <button
      onClick={handleClick}
      disabled={disabled}
      className={`relative inline-flex items-center justify-center p-2.5 rounded-lg transition-all duration-200 ease-in-out
        ${disabled
          ? 'bg-gray-100 text-gray-400 cursor-not-allowed dark:bg-gray-800/50 dark:text-gray-600'
          : isActive
            ? 'bg-blue-500 text-white hover:bg-blue-600 dark:bg-blue-600 dark:hover:bg-blue-700'
            : 'bg-blue-500/10 text-blue-600 hover:bg-blue-500/20 dark:bg-blue-500/20 dark:text-blue-400 dark:hover:bg-blue-500/30'}
        hover:scale-105 active:scale-95 group`}
      title={disabled ? 'Add channels to your playlist to share' : 'Share playlist'}
    >
      <Share2 className="w-5 h-5 transition-transform duration-200 group-hover:rotate-12" />
    </button>
  );
}; 